class Share {
	constructor() {
		const shareButton = document.querySelector(".share-container .share");
		if (!shareButton) {
			return;
		}
		if (navigator.share) {
			shareButton.addEventListener("click", () => {
				navigator.share({
					title: document.title,
					url: window.location.href
				}).then(() => {
				})
					.catch(console.error);
			});
		} else {
			shareButton.classList.remove("share");
			shareButton.classList.add("copy");
			const success = shareButton.querySelector(".success");
			const error = shareButton.querySelector(".error");
			shareButton.addEventListener("click", () => {
				if (navigator.clipboard) {
					navigator.clipboard.writeText(window.location.href)
						.then(() => {
							gsap.to(success, {
								opacity: 1,
								duration: 0.3,
								onComplete: () => {
									gsap.to(success, {
										opacity: 0,
										delay: 1
									});
								}
							});
						})
						.catch(() => {
							gsap.to(error, {
								opacity: 1,
								duration: 0.3,
								onComplete: () => {
									gsap.to(error, {
										opacity: 0,
										delay: 1
									});
								}
							});
						});
				} else {
					gsap.to(error, {
						opacity: 1,
						duration: 0.3,
						onComplete: () => {
							gsap.to(error, {
								opacity: 0,
								delay: 1
							});
						}
					});
				}

			});
		}
	}
}
